import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  TextField,
  CircularProgress,
  Paper,
  IconButton,
  InputAdornment,
} from "@mui/material";
import {
  ShoppingCart,
  RemoveCircleOutline,
  AddCircleOutline,
  Delete,
  Person,
  Email,
  Phone,
  LocationOn,
  PinDrop,
} from "@mui/icons-material";
import {
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Divider,
} from "@mui/material";
import { headers } from "../../utils/utils";

const Checkout = () => {
  const [contact, setContact] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    pincode: "",
  });
  const [loading, setLoading] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [saveForm, setSaveForm] = useState({});

  const [cart, setCart] = useState(() => {
    const savedCart = localStorage.getItem("cart");
    return savedCart ? JSON.parse(savedCart) : [];
  });
  const currency = "₹";

  const loadRazorpay = () => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    script.onload = () => openRazorpay();
    document.body.appendChild(script);
  };

  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);

  const openRazorpay = () => {
    const options = {
      key: "rzp_test_v0su4mmAdMHRar", // Replace with your Razorpay key_id
      amount:
        cart
          .reduce((total, item) => total + item.quantity * item.salePrice, 0)
          .toFixed(2) * 100, // The amount is in paise (100 paise = 1 INR)
      currency: "INR",
      name: "Vyoog Information Pvt Ltd",
      description: "Transaction",
      image: "https://www.vyoog.com/wp-content/uploads/2020/10/logon-new1.png",
      handler: function (response) {
        orderSave(response);
      },
      prefill: {
        name: contact.name,
        email: contact.email,
        contact: contact.phone,
      },
      theme: {
        color: "#3eabaf",
      },
    };

    const razorpay = new window.Razorpay(options);
    razorpay.open();
  };
  const [errors, setErrors] = useState({
    name: false,
    email: false,
    phone: false,
    address: false,
    pincode: false,
  });

  const processNextLoad = () => {
    // orderSave()
    handleProceedToPayment();
    // setLoading(true)
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setContact((prevContact) => ({ ...prevContact, [name]: value }));
    // Reset error state when the user starts typing
    setErrors((prevErrors) => ({ ...prevErrors, [name]: false }));
  };

  const validateFields = () => {
    const newErrors = {
      name: !contact.name,
      email:
        !contact.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contact.email),
      phone: !contact.phone || !/^\d{10}$/.test(contact.phone),
      address: !contact.address,
      pincode: !contact.pincode || !/^\d{6}$/.test(contact.pincode),
    };
    setErrors(newErrors);
    return !Object.values(newErrors).some(Boolean);
  };
  const handleProceedToPayment = async () => {
    // if (!validateFields()) {
    //     return; // Highlight errors if validation fails
    // }

    setLoading(true);
    loadRazorpay();
    setLoading(false);
  };

  const orderSave = async (resp) => {
    const formattedOrder = {
      orderNumber: "", // Assign order number if available
      orderDate: new Date().toISOString(), // Current timestamp
      status: "PENDING",
      customerId: "", // Assign customer ID if available
      orderItems: cart.map((item) => ({
        itemId: item.id || "ITEM001", // Replace with actual item ID
        quantity: item.quantity || 1,
        unitPrice: item.salePrice || 0.0,
        totalPrice: (item.quantity || 1) * (item.salePrice || 0.0),
        taxes: item.tax.map((tax) => ({
          name: tax.name,
          value: item.salePrice * item.quantity * (tax.percentage / 100), // Tax value for this tax
          percentage: tax.percentage,
        })),
      })),
      totalAmount: cart.reduce((sum, item) => {
        // Add item totalPrice and tax value
        const itemTotal = item.quantity * item.salePrice;
        const itemTaxes = item.tax.reduce((taxSum, tax) => {
          return (
            taxSum + item.salePrice * item.quantity * (tax.percentage / 100)
          );
        }, 0);

        return sum + itemTotal + itemTaxes;
      }, 0), // Initial value for sum is 0
      paymentMethod: "ONLINE",
      reference: response.razorpay_payment_id,
      shippingAddress: "123 Street, City",
    };

    const response = await fetch(process.env.REACT_APP_ORDER + `/order/save`, {
      method: "POST",
      body: JSON.stringify(formattedOrder),
      headers: headers(),
    });

    if (response.ok) {
      const result = await response.json();
      console.log("RESULT", result);
    }

    console.log(formattedOrder);
  };

  const calculateItemTax = (item) => {
    return item.tax.reduce(
      (totalTax, tax) =>
        totalTax + item.salePrice * item.quantity * (tax.percentage / 100),
      0,
    );
  };

  const calculateTotalWithTax = (item) => {
    return item.salePrice * item.quantity + calculateItemTax(item);
  };

  const updateQuantity = (id, change) => {
    setCart(
      cart.map((item) =>
        item.id === id
          ? { ...item, quantity: Math.max(1, item.quantity + change) }
          : item,
      ),
    );
  };

  const removeItem = (id) => {
    setCart(cart.filter((item) => item.id !== id));
  };
  return (
    <>
      <Box
        className="form-l1"
        sx={{
          margin: "0 auto",
          backgroundColor: "#fff",
          borderRadius: 4,
          boxShadow: 3,
          p: 4,
        }}
      >
        <Typography
          variant="h6"
          sx={{ display: "flex" }}
          fontWeight="bold"
          variant="button"
          align="center"
          gutterBottom
        >
          <ShoppingCart sx={{ mr: 1 }} /> Checkout
        </Typography>

        <Box sx={{ mb: 4 }}>
          {cart.length === 0 ? (
            <Typography align="center" color="text.secondary">
              Your cart is empty
            </Typography>
          ) : (
            <Grid container spacing={3} mt={2}>
              {cart.map((item) => (
                <Grid item xs={12} key={item.id}>
                  <Card sx={{ display: "flex", boxShadow: 0 }}>
                    <CardMedia
                      component="img"
                      sx={{
                        width: 120,
                        height: 120,
                        mt: 2,
                        ml: 2,
                        mb: 2,
                        objectFit: "cover",
                        borderRadius: 2,
                      }}
                      image={item.image}
                    />
                    <CardContent sx={{ flex: 1 }}>
                      <Typography fontWeight="bold" className="form-label">
                        {item.name}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {item.description}
                      </Typography>
                      <br />
                      <Typography variant="body2" color="text.primary">
                        {currency} {item.salePrice.toFixed(2)}
                      </Typography>
                    </CardContent>
                    <CardActions
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <IconButton
                          onClick={() => updateQuantity(item.id, -1)}
                          color="primary"
                        >
                          <RemoveCircleOutline />
                        </IconButton>
                        <Typography>{item.quantity}</Typography>
                        <IconButton
                          onClick={() => updateQuantity(item.id, 1)}
                          color="primary"
                        >
                          <AddCircleOutline />
                        </IconButton>
                        <IconButton
                          onClick={() => removeItem(item.id)}
                          color="error"
                        >
                          <Delete />
                        </IconButton>
                      </Box>

                      <Paper
                        elevation={1}
                        sx={{ p: 2, borderRadius: 4, backgroundColor: "white" }}
                      >
                        {/* Tax Breakdown */}
                        <Box sx={{ mb: 2 }}>
                          {item.tax.map((tax, index) => (
                            <Typography
                              key={index}
                              variant="body2"
                              sx={{
                                fontSize: "12px",
                                py: 0.5,
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                              color="text.secondary"
                            >
                              <span>
                                {tax.name} ({tax.percentage}%)
                              </span>
                              <span>
                                {currency}{" "}
                                {(
                                  item.salePrice *
                                  item.quantity *
                                  (tax.percentage / 100)
                                ).toFixed(2)}
                              </span>
                            </Typography>
                          ))}
                        </Box>

                        <Divider sx={{ my: 2 }} />

                        {/* Total Price */}
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            variant="h6"
                            fontWeight="bold"
                            color="text.secondary"
                          >
                            Total:
                          </Typography>
                          <Typography
                            variant="h6"
                            fontWeight="bold"
                            color="primary"
                          >
                            {currency} {calculateTotalWithTax(item).toFixed(2)}
                          </Typography>
                        </Box>
                      </Paper>
                    </CardActions>
                  </Card>
                  <hr className="hr" />
                </Grid>
              ))}
              <Grid container>
                <Grid item xs={9}></Grid>
                <Grid item xs={3}>
                  <Divider sx={{ my: 2 }} />
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      py: 1,
                    }}
                  >
                    <Typography
                      variant="h6"
                      fontWeight="bold"
                      color="text.secondary"
                    >
                      Total Tax:
                    </Typography>
                    <Typography variant="h6" fontWeight="bold" color="error">
                      {currency}{" "}
                      {cart
                        .reduce(
                          (total, item) => total + calculateItemTax(item),
                          0,
                        )
                        .toFixed(2)}
                    </Typography>
                  </Box>

                  <Divider sx={{ my: 1 }} />

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      py: 1,
                    }}
                  >
                    <Typography
                      variant="h6"
                      fontWeight="bold"
                      color="text.secondary"
                    >
                      Grand Total:
                    </Typography>
                    <Typography variant="h6" fontWeight="bold" color="primary">
                      {currency}{" "}
                      {cart
                        .reduce(
                          (total, item) => total + calculateTotalWithTax(item),
                          0,
                        )
                        .toFixed(2)}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
              <Grid item xs={12} align="right">
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  onClick={processNextLoad}
                  disabled={loading}
                  sx={{ borderRadius: 3 }}
                >
                  {loading ? "Processing..." : "Next"}
                </Button>
              </Grid>
            </Grid>
          )}
        </Box>

        {loading == true && (
          <>
            <Typography
              variant="h6"
              sx={{ display: "flex" }}
              fontWeight="bold"
              variant="button"
              align="center"
              gutterBottom
            >
              <Person sx={{ mr: 1 }} /> Contact & Address Details
            </Typography>

            <hr className="hr" />
            <Paper sx={{ p: 3, backgroundColor: "white", borderRadius: "8px" }}>
              <form>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Name"
                      fullWidth
                      name="name"
                      value={contact.name}
                      onChange={handleInputChange}
                      error={errors.name}
                      helperText={errors.name ? "Name is required" : ""}
                      margin="normal"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Person />
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": errors.name && {
                          borderColor: "green",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Email"
                      fullWidth
                      name="email"
                      value={contact.email}
                      onChange={handleInputChange}
                      error={errors.email}
                      helperText={errors.email ? "Valid email is required" : ""}
                      margin="normal"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Email />
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": errors.email && {
                          borderColor: "green",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Phone"
                      fullWidth
                      name="phone"
                      value={contact.phone}
                      onChange={handleInputChange}
                      error={errors.phone}
                      helperText={
                        errors.phone
                          ? "Valid 10-digit phone number is required"
                          : ""
                      }
                      margin="normal"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Phone />
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": errors.phone && {
                          borderColor: "green",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="Address"
                      fullWidth
                      name="address"
                      value={contact.address}
                      onChange={handleInputChange}
                      error={errors.address}
                      helperText={errors.address ? "Address is required" : ""}
                      margin="normal"
                      multiline
                      rows={4}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <LocationOn />
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": errors.address && {
                          borderColor: "green",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Pincode"
                      fullWidth
                      name="pincode"
                      value={contact.pincode}
                      onChange={handleInputChange}
                      error={errors.pincode}
                      helperText={
                        errors.pincode
                          ? "Valid 6-digit pincode is required"
                          : ""
                      }
                      margin="normal"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <PinDrop />
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": errors.pincode && {
                          borderColor: "green",
                        },
                      }}
                    />
                  </Grid>
                </Grid>
                <Box mt={4} textAlign="center">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleProceedToPayment}
                    sx={{ width: "100%" }}
                  >
                    Proceed to Payment
                  </Button>
                </Box>
              </form>
            </Paper>
          </>
        )}
      </Box>
    </>
  );
};

export default Checkout;
